import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2e2842e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ds-modal__header-content" }
const _hoisted_2 = { class: "ds-modal__title" }

import { computed } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import DSButton from './DSButton.vue';

interface Props {
  modelValue: boolean;
  title?: string;
  message?: string;
  persistent?: boolean;
  maximized?: boolean;
  loading?: boolean;
  confirmLabel?: string;
  hasFooter?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSModal',
  props: {
    modelValue: { type: Boolean },
    title: { default: '' },
    message: { default: '' },
    persistent: { type: Boolean, default: false },
    maximized: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    confirmLabel: { default: 'Confirm' },
    hasFooter: { type: Boolean, default: true }
  },
  emits: ['update:modelValue', 'confirm', 'cancel', 'hide'],
  setup(__props: any, { emit }) {

const props = __props;





const $q = useQuasar();

const isOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const cardStyle = computed(() => ({
  minWidth: $q.screen.width > 450 ? '450px' : '100%',
}));

const close = () => {
  isOpen.value = false;
  emit('cancel');
};

const confirm = () => {
  emit('confirm');
};

const onHide = () => {
  emit('hide');
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    persistent: _ctx.persistent,
    maximized: _ctx.maximized,
    onHide: onHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        style: _normalizeStyle(cardStyle.value),
        class: "ds-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "ds-modal__header q-pb-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
                _createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: "",
                  onClick: close,
                  "aria-label": "Close modal"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_section, { class: "ds-modal__body" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "body", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.message), 1)
              ])
            ]),
            _: 3
          }),
          (_ctx.hasFooter)
            ? (_openBlock(), _createBlock(_component_q_card_actions, {
                key: 0,
                class: "ds-modal__footer q-pt-none",
                align: "right"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createVNode(DSButton, {
                      label: "Cancel",
                      variant: "outline",
                      onClick: close
                    }),
                    _createVNode(DSButton, {
                      label: _ctx.confirmLabel,
                      loading: _ctx.loading,
                      onClick: confirm
                    }, null, 8, ["label", "loading"])
                  ])
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["style"])
    ]),
    _: 3
  }, 8, ["modelValue", "persistent", "maximized"]))
}
}

})